const messages = {
  en: {
    copyright: 'All Rights Reserved.'
  },
  'es-ud': {
    copyright: 'Todos los Derechos Reservados.'
  },
  es: {
    copyright: 'Todos los Derechos Reservados.'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/Footer/messages.js